import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import useTheme from '../../theme/useTheme'

import { selectAgentName } from '~/agent/store/agent.selectors'
import { CHANGE_BRAND } from '~/modal/constants/messages'
import useModal from '~/modal/hooks/useModal'
import ModalMessages from '~/modal/models/modal.model'
import useResetSale from '~/sale/hooks/useResetSale'

interface useSalesHeaderProps {
  agentName?: string
  onSelectModalMessage: (modalType: string, param: string) => void
}

export default function useSalesHeader(): useSalesHeaderProps {
  const { selectAndOpenModalFromList } = useModal()
  const { theme, setTheme } = useTheme()
  const [selectedBrand, setSelectedBrand] = useState(theme.name)
  const [messageName, setMessageName] = useState('')
  const { resetSale } = useResetSale()
  const agentName = useSelector(selectAgentName)

  function onChangeBrand() {
    setTheme(selectedBrand)
    resetSale(selectedBrand)
  }

  const salesHeaderModalMessages: ModalMessages = {
    CHANGE_BRAND: {
      open: false,
      title: CHANGE_BRAND.title,
      description: CHANGE_BRAND.description,
      actions: [
        {
          button: { variant: 'contained', size: 'medium', color: 'secondary' },
          name: CHANGE_BRAND.actions.continue,
          fn: () => onChangeBrand(),
        },
        {
          button: { variant: 'outlined', size: 'medium', color: 'secondary' },
          name: CHANGE_BRAND.actions.cancel,
        },
      ],
      type: 'warning',
    },
  }

  useEffect(() => {
    if (messageName) {
      selectAndOpenModalFromList(messageName, salesHeaderModalMessages)
    }
    return () => setMessageName('')
  }, [messageName, selectedBrand])

  function onSelectModalMessage(messageType: string, param: string) {
    switch (messageType) {
      case 'CHANGE_BRAND':
        setSelectedBrand(param)
        break
      default:
        break
    }
    setMessageName(messageType)
  }

  return {
    agentName,
    onSelectModalMessage,
  }
}
